// Distinct unicode pieces per color for clarity
const PIECES_BY_COLOR = {
  white: [
    { symbol: '♕', value: 'q', name: 'Queen' },
    { symbol: '♖', value: 'r', name: 'Rook' },
    { symbol: '♗', value: 'b', name: 'Bishop' },
    { symbol: '♘', value: 'n', name: 'Knight' },
  ],
  black: [
    { symbol: '♛', value: 'q', name: 'Queen' },
    { symbol: '♜', value: 'r', name: 'Rook' },
    { symbol: '♝', value: 'b', name: 'Bishop' },
    { symbol: '♞', value: 'n', name: 'Knight' },
  ],
}

export default function PromotionModal({ playerColor, onSelect, onCancel }) {
  const pieces = PIECES_BY_COLOR[playerColor] ?? PIECES_BY_COLOR.white

  function stopPropagation(e) { e.stopPropagation() }

  return (
    <div
      className="fixed inset-0 modal-backdrop z-50 flex items-center justify-center p-4 animate-fade-in"
      onClick={onCancel}
    >
      <div className="card-elevated p-6 max-w-xs w-full text-center animate-slide-up" onClick={stopPropagation}>
        <h3 className="font-display text-xl font-semibold text-ivory-100 mb-1">Pawn Promotion</h3>
        <p className="text-ivory-300/50 text-sm mb-6">Choose a piece to promote to</p>

        <div className="grid grid-cols-4 gap-2 mb-4">
          {pieces.map((piece) => (
            <button
              key={piece.value}
              onClick={() => onSelect(piece.value)}
              className="flex flex-col items-center gap-1 p-3 rounded-xl bg-obsidian-700 border border-obsidian-500 hover:bg-obsidian-600 hover:border-gold-500/50 transition-all duration-200 group"
            >
              <span className="text-3xl group-hover:scale-110 transition-transform duration-200">
                {piece.symbol}
              </span>
              <span className="text-[10px] text-ivory-300/40 font-mono">{piece.name}</span>
            </button>
          ))}
        </div>

        <button onClick={onCancel} className="btn-ghost text-sm w-full">
          Cancel
        </button>
      </div>
    </div>
  )
}
